import React, { useEffect } from "react";
import { Container } from "reactstrap";
import { useDispatch } from "react-redux";

import historyActions from "../../redux/history/action";

const PensionCalculatorWebview = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const { history } = props;

    dispatch(historyActions.setHistory(history));
  }, []);

  return (
    <Container className="my-3" style={{ flex: 1 }}>
      <iframe
        title="pension-calculator"
        className="w-100 h-100"
        src="https://premiumpension.com/calculator/"
      ></iframe>
    </Container>
  );
};

export default PensionCalculatorWebview;
